<template>
  <div>
    <h4>Daily active users</h4>
    <apexchart
      width="500"
      type="line"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "dau-graphic-component",
})
export default class DauGraphicComponent extends Vue {
  options = {
    chart: {
      id: "dau-chart",
      toolbar: {
        show: false,
      },
      height: 200,
    },
    xaxis: {
      categories: [
        "00:00",
        "02:00",
        "04:00",
        "06:00",
        "08:00",
        "10:00",
        "12:00",
        "14:00",
        "16:00",
        "18:00",
        "20:00",
        "22:00",
      ],
    },

    stroke: {
      curve: "smooth",
    },
    dropShadow: {
      enabled: true,
      top: 0,
      left: 0,
      blur: 3,
      opacity: 0.5,
    },
    grid: {
      show: false,
    },
  };
  series = [
    {
      name: "series-1",
      data: [100, 50, 120, 30, 10, 10, 15, 25, 60, 100, 50, 10],
    },
  ];
}
</script>
